import { ACTION } from './hot_water_system_actions';

const initialState = {
  boilerTypeList: [],
  heatPumpTypeList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ACTION.LIST_BOILER_TYPE}_FULFILLED`:
      return {
        ...state,
        boilerTypeList: action.payload,
      };
    case `${ACTION.LIST_HEAT_PUMP_TYPE}_FULFILLED`:
      return {
        ...state,
        heatPumpTypeList: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/references/hot_water_system_reducer.js